import { jsx } from "react/jsx-runtime";
import { Box, styled } from "@mui/material";
const Root = styled((props) => /* @__PURE__ */ jsx(Box, { ...props, component: "header" }), {
  slot: "FormHeader"
})(() => ({
  paddingBottom: 2,
  paddingLeft: 2,
  paddingRight: 2
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
